export default __webpack_public_path__ + "6983dfaac27f814e905b7e2536b2ef59.png";